module.exports = __webpack_public_path__ + "static/img/女式背心套.795c1f6f.jpg";